<template>

  <div id="app">
    <div class="title">
      资料
      <a style="margin-left:81%;color:green;" href="javascript:void(0);" @click="updateInformation">{{updateBtn}}</a>
    </div>
    
    <div class="field">
      <label>姓名:</label>
      <span class="cnt">{{user.name!=null && user.name != ''?user.name:'未认证'}}</span>
      <span class="opt"></span>
    </div>

    <div class="field">
      <label>用户名</label>
      <span class="cnt"><input type="text" v-if="update"  v-model="userName"/><span v-if="!update">{{user.userName}}</span></span>
      <!-- <span class="opt"><a href="javascript:void(0);" @click="updateUserName">{{update_userName}}</a></span> -->
    </div>
    
    <div class="field">
      <label>手机号:</label>
      <span class="cnt">{{user.phone}}</span>
    </div>

    <div class="field">
      <label>头像</label>
      <span style="mrgin-left:20px;color:red;" v-show="updateSure">注：点击头像进行更换头像</span>
      <!-- <span class="update_img"><a href="javascript:void(0);" @click="update_img">修改头像</a></span> -->

      <div class="div_img">
        <el-upload
          action="/api/authority/updateImg"
          name="file"
          ref="upload"
          :auto-upload="false"
          :show-file-list="false"
          :on-change="handleChange"
          :on-success="onSuccess"
          :limit="1"
          accept="image/png,image/jpg,image/jpeg"
          >
          <img v-if="imageUrl" :src="imageUrl" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </div>
    </div>

    <div class="field">
      <label>修改密码</label>
      <span class="cnt"></span>
      <span class="opt"><a href="javascript:void(0);" @click="resetPwd">去修改</a></span>
    </div>
    <!--
    <div class="field">
      <label>邮箱:</label>
      <span class="cnt">未添加邮箱</span>
      <span class="opt">修改</span>
    </div>
    -->

    <div class="field">
      <label>实名认证:</label>
      <span v-if="user.certification==0">未认证</span>
      <span v-if="user.certification==1" class="cnt">个人认证 <img  class="right" src="/static/images/right.png"/></span>
       <span v-if="user.certification==2" class="cnt">企业认证 <img  class="right" src="/static/images/right.png"/></span>
    </div>


  </div>
</template>
<style scoped src="../../../static/css/Common.css"></style>
<style scoped src="../../../static/css/Information.css"></style>

<script>
import { updateImgApi,updateUserNameApi } from '../../service/allApi';
export default {
  data(){
    return {
      user:{},
      imageUrl: '/static/images/my_user.jpg',
      fileList:[],
      update:false,
      userName:'',
      loading:null,
      updateBtn:"修改",
      updateSure:false
    }
  },
  created(){
    this.user = JSON.parse( localStorage.getItem('user'))
    this.imageUrl = this.user.img
    this.userName = this.user.userName
  },
  methods:{
    resetPwd(){
      window.parent.toUrl( "/resetpassword" );
    },
      update_img(){
        if(this.fileList.length<=0 || this.fileList == null){
          this.$message({
            message: '点击头像，选择需要更换的头像',
            type: 'error'
          });
          // this.loading.close();
          return
        }
         this.loading = this.$loading({
                  lock: true,
                  text: 'Loading',
                  spinner: 'el-icon-loading',
                  background: 'rgba(0, 0, 0, 0.7)'
                });

        this.$refs.upload.submit();
      },
      handleChange(file,fileList){
        // console.log(fileList)
        this.fileList = fileList;
        this.imageUrl = URL.createObjectURL(file.raw)
      },
      onSuccess(response){
        if(response.code == 100){
          this.user = response.data.user
          this.imageUrl = this.user.img
          this.$message({
            message: '修改成功',
            type: 'success'
          });
          this.loading.close();
          localStorage.setItem("img",this.imageUrl);
        }else if(response.code == -200){
          this.$message.warning('登录已超时，请重新登录')
        }else{
          this.$message.err('文件:' + file.name + "  上传失败") 
        }
      },
    //  async updateUserName(){
    //       if(this.update){
    //         // alert(this.userName)
    //         this.update_userName = "修改用户名";
    //           if(this.userName=="" || this.userName==null){
    //               alert('请输入用户名')
    //               return
    //           }
    //           var data = {
    //             userName:this.userName
    //           }
    //          var res = await  updateUserNameApi(data);
    //          if(res.data.code == 100){
    //             alert("用户名修改成功")
    //             this.user.userName = this.userName
    //          }else{
    //          }
    //       }else{
    //          this.update_userName = "确认修改";
    //       }
    //       this.update = !this.update
    //   },
     async  updateInformation(){
        if(this.update){
            // alert(this.userName)
            this.updateBtn = "修改";
              var data = {
                userName:this.userName
              }
             var res = await  updateUserNameApi(data);
             if(res.data.code == 100){
                this.user.userName = this.userName
                 if(this.fileList.length>=0 && this.fileList != null){
                    this.$refs.upload.submit();
                }
             }else{
             }
          }else{
             this.updateBtn = "确认修改";
          }
          this.update = !this.update
          this.updateSure = !this.updateSure
      }
  }

}
</script>

<style scoped>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 60px;
    height: 60px;
    line-height: 60px;
    text-align: center;
  }
  .avatar {
    width: 60px;
    height: 60px;
    display: block;
  }

  .div_img{
    float: right;
    margin-right: 20px;
  }
  .update_img{
    float: right;
    margin-left: 20px;
  }
</style>




// WEBPACK FOOTER //
// src/components/iframe/Information.vue